import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Star, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Watchlist({ refreshKey, onSelectTicker }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/watchlist");
      setItems(data);
    } catch (e) {
      // Silent — user is not logged in yet; watchlist just stays empty.
      console.debug("[Watchlist] load skipped (likely not authenticated):", e?.response?.status);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, [refreshKey]);

  const remove = async (id) => {
    try {
      await api.delete(`/api/watchlist/${id}`);
      setItems(items.filter((i) => i.item_id !== id));
      toast.success("Removed from watchlist");
    } catch (e) {
      toast.error("Failed to remove");
    }
  };

  return (
    <div className="card-surface p-5 fade-in" data-testid="watchlist">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-xl bg-white/[0.06] border border-white/10 flex items-center justify-center">
            <Star className="w-3.5 h-3.5 text-white" />
          </div>
          <div>
            <div className="label-mono">Watchlist</div>
            <h3 className="text-[15px] text-white font-semibold tracking-tight mt-0.5">Tracked</h3>
          </div>
        </div>
        <div className="label-mono">{items.length}</div>
      </div>
      <div className="space-y-1.5">
        {items.length === 0 && !loading && (
          <div className="text-white/40 text-xs py-6 text-center label-mono">Add tickers from results</div>
        )}
        {items.map((it) => (
          <div key={it.item_id}
            className="flex items-center justify-between px-3 py-2.5 rounded-xl bg-white/[0.025] border border-white/5 hover:border-white/15 hover:bg-white/[0.045] transition-all cursor-pointer"
            onClick={() => onSelectTicker && onSelectTicker(it.ticker)}
            data-testid={`watchlist-item-${it.ticker}`}>
            <div>
              <div className="text-white text-[13px] font-semibold tracking-tight">{it.ticker}</div>
              <div className="text-white/40 text-[10px] font-mono uppercase tracking-wider mt-0.5">{it.asset_class}</div>
            </div>
            <button onClick={(e) => { e.stopPropagation(); remove(it.item_id); }}
              className="text-white/40 hover:text-[var(--bear)] p-1.5 transition-colors"
              data-testid={`watchlist-remove-${it.ticker}`}>
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
